// src/components/PaymentMethodSelector.jsx
import React from "react";
import creditCard from "../assets/images/credit-card.png";
import mastercardImg from "../assets/images/mastercard.png";
import amex from "../assets/images/amex.png";
import paypal from "../assets/images/paypal.png";

const PaymentMethodSelector = ({ paymentOption, setPaymentOption }) => {
  return (
    <div className="d-block my-3">
      {/* Visa Option */}
      <div
        className={`custom-control custom-radio d-flex align-items-center gap-2 ${
          paymentOption === "visa" ? "bg-dark text-light" : "bg-light text-dark"
        } p-2 rounded-4 mb-2`}
      >
        <input
          id="visa"
          name="paymentMethod"
          type="radio"
          className="custom-control-input"
          value="visa"
          checked={paymentOption === "visa"}
          onChange={(e) => setPaymentOption(e.target.value)}
        />
        <label className="custom-control-label mb-0" htmlFor="visa">
          <img src={creditCard} width={40} alt="Visa" />
          &nbsp;Visa Credit Card
        </label>
      </div>
      {/* MasterCard Option */}
      <div
        className={`custom-control custom-radio d-flex align-items-center gap-2 ${
          paymentOption === "mastercard"
            ? "bg-dark text-light"
            : "bg-light text-dark"
        } p-2 rounded-4 mb-2`}
      >
        <input
          id="mastercard"
          name="paymentMethod"
          type="radio"
          className="custom-control-input"
          value="mastercard"
          checked={paymentOption === "mastercard"}
          onChange={(e) => setPaymentOption(e.target.value)}
        />
        <label className="custom-control-label mb-0" htmlFor="mastercard">
          <img src={mastercardImg} width={40} alt="MasterCard" />
          &nbsp;MasterCard
        </label>
      </div>
      {/* American Express Option */}
      <div
        className={`custom-control custom-radio d-flex align-items-center gap-2 ${
          paymentOption === "amex" ? "bg-dark text-light" : "bg-light text-dark"
        } p-2 rounded-4 mb-2`}
      >
        <input
          id="amex"
          name="paymentMethod"
          type="radio"
          className="custom-control-input"
          value="amex"
          checked={paymentOption === "amex"}
          onChange={(e) => setPaymentOption(e.target.value)}
        />
        <label className="custom-control-label mb-0" htmlFor="amex">
          <img src={amex} width={40} alt="American Express" />
          &nbsp;American Express
        </label>
      </div>
      {/* PayPal Option */}
      <div
        className={`custom-control custom-radio d-flex align-items-center gap-2 ${
          paymentOption === "paypal"
            ? "bg-dark text-light"
            : "bg-light text-dark"
        } p-2 rounded-4 mb-2`}
      >
        <input
          id="paypal"
          name="paymentMethod"
          type="radio"
          className="custom-control-input"
          value="paypal"
          checked={paymentOption === "paypal"}
          onChange={(e) => setPaymentOption(e.target.value)}
        />
        <label className="custom-control-label mb-0" htmlFor="paypal">
          <img src={paypal} width={40} alt="PayPal" />
          &nbsp;PayPal
        </label>
      </div>
    </div>
  );
};

export default PaymentMethodSelector;
